import React from 'react';
import ExcerptHeroRo from '../../components/excerpt/ro/ExcerptHeroRo';
import ExcerptNoteRo from '../../components/excerpt/ro/ExcerptNoteRo';
import ExcerptTextRo from '../../components/excerpt/ro/ExcerptTextRo';
import ExcerptCtaRo from '../../components/excerpt/ro/ExcerptCtaRo';

const ExcerptPageRo = () => (
  <main>
    <ExcerptHeroRo />
    <ExcerptNoteRo />
    <ExcerptTextRo />
    <ExcerptCtaRo />
  </main>
);

export default ExcerptPageRo;